import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DocumentTitleManager } from './components/layout/DocumentTitleManager';
import { AuthProvider } from './contexts/AuthContext';
import { MessageBoxProvider } from './contexts/MessageBoxContext';
import { PermissionsProvider } from './contexts/PermissionsContext';
import { AppRoutes } from './routes/AppRoutes';

export function App() {
  return (
    <BrowserRouter>
      <DocumentTitleManager />
      <AuthProvider>
        <PermissionsProvider>
          <MessageBoxProvider>
            <AppRoutes />
            <ToastContainer position="top-right" autoClose={4000} />
          </MessageBoxProvider>
        </PermissionsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
